import { createSlice } from '@reduxjs/toolkit';
interface IStyleReviewState {
    lastReviewStyleIds: null | string[];
}
const initialState: IStyleReviewState = {
    lastReviewStyleIds: null,
};
// Action =====================================================
const styleReviewSlice = createSlice({
    name: 'style',
    initialState,
    reducers: {
        setLastReviewStyleIds: (state, action) => {
            const lastReviewStyleId = action.payload;
            // if lastReviewStyleId is null, reset it, otherwise add it to the state, ensure it's an array with unique values and max length of 10
            if (!lastReviewStyleId) {
                state.lastReviewStyleIds = null;
                return;
            }
            if (!Array.isArray(state.lastReviewStyleIds)) {
                state.lastReviewStyleIds = [lastReviewStyleId];
                return;
            }
            const lastReviewStyleIds = [...state.lastReviewStyleIds, lastReviewStyleId];
            state.lastReviewStyleIds = Array.from(new Set(lastReviewStyleIds)).slice(-10);
        },
    },
});

// Selector =====================================================
export const { setLastReviewStyleIds } = styleReviewSlice.actions;
// Reducer=====================================================
const styleReviewReducer = styleReviewSlice.reducer;
export default styleReviewReducer;
